import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=5d4d1d3b&scoped=true&"
import script from "./ProductSlider.vue?vue&type=script&lang=ts&"
export * from "./ProductSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSlider.vue?vue&type=style&index=0&id=5d4d1d3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d1d3b",
  null
  
)

export default component.exports